import schemeTable from '../schemes/schemeTable';
let {tableSortStates} = schemeTable;
export default {
    /**
     * @property {number} sortState - текущее состояние режима сортировки
     * @property {object} sortStates - режимы сортировки
     * @property {string} sortColumn - колонка, по которой выполняется сортировка
     * @property {object} month - месяца для сортировки
     */
    data: () => ({
        sortState: 0,
        sortStates: tableSortStates,
        sortColumn: '',
        month: {
            1: 'Янв',
            2: 'Фев',
            3: 'Мар',
            4: 'Апр',
            5: 'Май',
            6: 'Июн',
            7: 'Июл',
            8: 'Авг',
            9: 'Сен',
            10: 'Окт',
            11: 'Ноя',
            12: 'Дек'
        }
    }),
    methods: {
        /**
         * сортировка численных данных в объекте map
         * @param {string} type - тип сортировки
         * @param {Map} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем
         * @property {boolean} isObjectCell - для ячеек с отображением разницы
         */
        sortNumberMap(type, rows = new Map(), sortColumn = '', isObjectCell = false) {
            let sortedRows;
            if(isObjectCell){
                sortedRows = new Map([...rows].sort((strA, strB) => {
                    let a = Number(strA[1][sortColumn]['val']);
                    let b = Number(strB[1][sortColumn]['val']);
                    return a - b;
                }));
            }else{
                sortedRows = new Map([...rows].sort((strA, strB) => {
                    let a = Number(strA[1][sortColumn]);
                    let b = Number(strB[1][sortColumn]);
                    return a - b;
                }));
            }
            return type === 'increase' ? sortedRows : new Map([...sortedRows].reverse());
        },
        /**
         * сортировка строковых данных в объекте map
         * @param {string} type - тип сортировки
         * @param {Map} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем 
         */
        sortStringMap(type, rows = new Map(), sortColumn = '') {
            let sortedRows = new Map([...rows].sort((strA, strB) => {
                let a = typeof strA[1][sortColumn] === 'string' ? strA[1][sortColumn].toLowerCase() : '';
                let b = typeof strB[1][sortColumn] === 'string' ? strB[1][sortColumn].toLowerCase() : '';
                if (a > b)
                    return 1;
                if (a < b)
                    return -1;
                return 0;
            }));
            return type === 'increase' ? sortedRows : new Map([...sortedRows].reverse());
        },
        /**
         * сортировка процентных данных в объекте map
         * @param {string} type - тип сортировки
         * @param {Map} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем 
         */
        sortPercentMap(type, rows = new Map(), sortColumn = '') {
            let sortedRows = new Map([...rows].sort((strA, strB) => {
                let a = Number(strA[1][sortColumn].split('%')[0]);
                let b = Number(strB[1][sortColumn].split('%')[0]);

                return a - b;
            }));
            return type === 'increase' ? sortedRows : new Map([...sortedRows].reverse());
        },
        /**
         * сортировка численных данных в массиве
         * @param {string} type - тип сортировки
         * @param {array} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем
         * @property {boolean} isObjectCell - флаг для ячеек с разницей
         */
        sortNumberArray(type, rows = [], sortColumn = '', isObjectCell = false) {
            let sortedRows;
            if(isObjectCell){
                sortedRows = rows.sort((strA, strB) => Number(strA[sortColumn]['val']) - Number(strB[sortColumn]['val']));
            }else{
                sortedRows = rows.sort((strA, strB) => Number(strA[sortColumn]) - Number(strB[sortColumn]));
            }
            return type === 'increase' ? sortedRows : sortedRows.reverse();
        },
        /**
         * сортировка строковых данных в массиве
         * @param {string} type - тип сортировки
         * @param {array} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем 
         */
        sortStringArray(type, rows = [], sortColumn = '') {
            let sortedRows = rows.sort((strA, strB) => {
                if (strA[sortColumn] > strB[sortColumn])
                    return 1;
                if (strA[sortColumn] < strB[sortColumn])
                    return -1;
                return 0;
            });
            return type === 'increase' ? sortedRows : sortedRows.reverse();
        },
        /**
         * сортировка процентных данных в массиве
         * @param {string} type - тип сортировки
         * @param {array} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем 
         */
        sortPercentArray(type, rows = [], sortColumn = '') {
            let sortedRows = rows.sort((strA, strB) => {
                let a = Number(strA[sortColumn].split('%')[0]);
                let b = Number(strB[sortColumn].split('%')[0]);
                return a - b;
            });
            return type === 'increase' ? sortedRows : sortedRows.reverse();
        },
        /**
         * сортировка месячных данных в массиве
         * @param {string} type - тип сортировки
         * @param {array} rows - строки
         * @property {string} sortColumn - колонка по которой сортируем 
         */
        sortMonthArray(type, rows = [], sortColumn = '') {
            let sortedRows = rows.sort((strA, strB) => {
                let monthKeyA = 1;
                let monthKeyB = 1;
                for (const [key, value] of Object.entries(this.month)) {
                    if (value === strA[sortColumn])
                        monthKeyA = Number(key);
                    if (value === strB[sortColumn])
                        monthKeyB = Number(key);
                }
                return monthKeyA - monthKeyB;
            });
            return type === 'increase' ? sortedRows : sortedRows.reverse();
        }
    }
}